import React from 'react';
import { Paper, IconButton } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { ptBR } from "@mui/x-data-grid/locales";
import { StopCircle, PlayCircle } from '@mui/icons-material';
import { D, Loading } from '../include';

export class Daemons extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      loading: true,
      page: 0,
      pageSize: 25,
      totalRows: 0, 
    };
  }

  componentDidMount = () => {
    this.updateData(this.state.page, this.state.pageSize);
  };

  updateData = (page, pageSize) => {
    this.setState({ loading: true });

    this.props.api
      .get('/Daemons', { params: { page, pageSize } })
      .then((response) => {
        const rows = response.daemons || [];
        const totalRows = Number(response.total) || 0;
        this.updateTable(rows, totalRows);
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  updateTable = (rows, totalRows) => {
    rows = Array.isArray(rows) ? rows : this.state.dataTable;

    const dataTable = rows.map((row, index) => ({
      id: index + this.state.page * this.state.pageSize,
      ...row,
      status: null,
    }));

    Promise.all(
      dataTable.map((row) =>
        this.props.api
          .post('Daemon/status', { name: row.value })
          .then((r) => ({
            ...row,
            status: r.status,
          }))
          .catch(() => ({ ...row, status: 'unknown' }))
      )
    ).then((updatedRows) => {
      this.setState({ dataTable: updatedRows, totalRows, loading: false });
    });
  };

  handlePaginationModelChange = (newpagemodel, reason) => {
    var pageSizeChanged = (newpagemodel.pageSize === this.state.pageSize) ? false : true
        
    this.setState({ page: newpagemodel.page, pageSize: newpagemodel.pageSize }, () => {
      this.updateData(pageSizeChanged ? 0 : newpagemodel.page, newpagemodel.pageSize);
    });
  };

  render() {
    const { dataTable, loading, page, pageSize, totalRows } = this.state;

    const columns = [
      {
        field: 'control',
        headerName: 'Controle',
        align: 'center',
        headerAlign: 'center',
        width: 100,
        renderCell: (params) => {
          const { status } = params.row;
          const isOff = status === 'off';
          const icon = isOff ? <PlayCircle /> : <StopCircle />;
          return (
            <IconButton
              style={{ color: '#aaa' }}
              onClick={() => {
                const action = isOff ? 'start' : 'stop';
                this.props.api
                  .post(`/Daemon/${action}`, { name: params.row.value })
                  .then(() => {
                    this.props.api
                      .post('Daemon/status', { name: params.row.value })
                      .then((r) => {
                        this.setState((prevState) => {
                          const dataTable = prevState.dataTable.map((row) => {
                            if (row.id === params.row.id) {
                              return { ...row, status: r.status };
                            } else {
                              return row;
                            }
                          });
                          return { dataTable };
                        });
                      });
                  });
              }}
            >
              {icon}
            </IconButton>
          );
        },
      },
      {
        field: 'status',
        headerName: 'Status',
        align: 'center',
        headerAlign: 'center',
        width: 100,
        renderCell: (params) => {
          const { status } = params.row;
          if (status === null) {
            return <Loading />;
          } else {
            const color = status === 'off' ? 'red' : 'green';
            const text = status === 'off' ? 'Inativo' : 'Ativo';
            return <span style={{ color, fontWeight: 'bold' }}>{text}</span>;
          }
        },
      },
      {
        field: 'value',
        headerName: 'Serviço',
        flex: 1,
      },
      {
        field: 'description',
        headerName: 'Descrição',
        flex: 2,
      },
    ];

    return (
      <D className="col e aF scD" style={{ padding: '2rem' }}>
        <Paper sx={{ width: '100%', height: '800px' }}>
          <DataGrid
            rows={dataTable || []}
            columns={columns || []}
            pagination
            paginationMode="server"
            rowCount={Number(totalRows)}
            loading={loading}            
            pageSizeOptions={[25, 50, 100]}
            paginationModel={{pageSize: pageSize, page: page} }
            onPaginationModelChange={this.handlePaginationModelChange}            
            disableSelectionOnClick
            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText} 
            components={{
              NoRowsOverlay: () => (
                <D style={{ padding: '2rem', textAlign: 'center' }}>
                  Nenhum daemon encontrado
                </D>
              ),
              LoadingOverlay: () => (
                <D style={{ padding: '2rem', textAlign: 'center' }}>
                  <Loading />
                </D>
              ),
            }}
          />
        </Paper>
      </D>
    );
  }
}
